import {ChangeDetectionStrategy, Component} from '@angular/core';
import {GetStartedService} from '../../layout/header/get-started.service';
import { TeamMemberCardComponent } from './team-member-card/team-member-card.component';


@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TeamMemberCardComponent]
})
export class AboutComponent {

  constructor(public gs: GetStartedService) {
  }
}
